BaseModel = require './base_model.coffee'

class global.EmailStatistic extends BaseModel
  @ATTRIBUTES =
    id: {}
    sent: { type: Number }
    accepted: { type: Number }
    rejected: { type: Number }
    delivery: { type: Number }
    bounce: { type: Number }
    open: { type: Number }
    reply: { type: Number }

  openPercentage: ->
    @formattedPercentage @open

  replyPercentage: (recipients_count) ->
    @formattedPercentage @reply, recipients_count

  formattedPercentage: (value, total = null) ->
    total ?= @sent
    if total > 0
      percentage = ((parseFloat(value) / total) * 100.0).toFixed(1)
      percentage.replace('.', ',') + '%'
    else
      '--'

  humanLabel: (field) ->
    attributes =
      sent: 'Enviados'
      accepted: 'Recebidos'
      rejected: 'Rejeitados'
      delivery: 'Entregues'
      bounce: 'Rejeitados'
      open: 'Abertos'
      reply: 'Respondidos'

    attributes[field]



// WEBPACK FOOTER //
// ./src/models/email_statistic.coffee